import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ItemMeetingInfoStatistics = ({ labelKey, content }) => {
    const { t } = useTranslation();

    return (
        <Typography display={'flex'}>
            {t(labelKey)}:
            <Typography fontWeight={700} ml={0.5}>
                {content}
            </Typography>
        </Typography>
    );
};

export default ItemMeetingInfoStatistics;
